"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setUpMenu = undefined;

var _bodyScrollLock = require("body-scroll-lock");

var removeSubLinksFromTabIndex = function removeSubLinksFromTabIndex(subNavLinks) {
  subNavLinks.forEach(function (link) {
    link.setAttribute("tabindex", "-1");
  });
};

var addSubLinksFromTabIndex = function addSubLinksFromTabIndex(subNavLinks) {
  subNavLinks.forEach(function (link) {
    link.setAttribute("tabindex", "0");
  });
};

var closeAllSubNav = function closeAllSubNav() {
  console.log("close");
  (0, _bodyScrollLock.clearAllBodyScrollLocks)();
  var menuItemsWithChildren = document.querySelectorAll(".nav-item--has-children");
  var body = document.querySelector("body");
  if (menuItemsWithChildren.length) {
    menuItemsWithChildren.forEach(function (menu) {
      var subNavLink = menu.querySelector(".nav-item__link");
      var subNav = menu.querySelector(".sub-nav");
      var overlayEl = document.querySelector(".menu-overlay");
      subNav.classList.remove("sub-nav--isActive");
      subNavLink.setAttribute("aria-expanded", "false");
      subNavLink.classList.remove("is-active");
      body.classList.remove("subMenuIsOpen");
      overlayEl.classList.remove("is-shown");
      overlayEl.classList.add("is-hidden");
    });
  }
};

var showArrowInCorrectSpot = function showArrowInCorrectSpot(element) {
  var boundingRect = element.getBoundingClientRect();
  var arrowToMoveWrapper = element.parentNode.querySelector(".sub-nav__arrow");
  var arrowToMoveWrapperBoundingRect = arrowToMoveWrapper.getBoundingClientRect();
  var windowWidth = window.innerWidth;
  var arrow = arrowToMoveWrapper.querySelector(".arrow__icon");
  var arrowWidth = arrow.clientWidth;

  console.log(arrowWidth);
  console.log("arrow", arrowToMoveWrapperBoundingRect);
  console.log("link", boundingRect);
  arrowToMoveWrapper.style.position = "absolute";
  arrowToMoveWrapper.style.right = "\n    calc(\n    " + windowWidth + "px -\n    " + boundingRect.right + "px \n    + (" + boundingRect.width + "px / 2)  + (" + arrowWidth + "px / 2))";
  arrowToMoveWrapper.style.top = 0;
};

var toggleNav = function toggleNav(e) {
  var subNavParent = e.parentNode;
  var subNavAriaExpanded = e.getAttribute("aria-expanded");
  var subNavLinks = subNavParent.querySelectorAll(".sub-nav__link");
  var body = document.querySelector("body");
  var subNav = subNavParent.querySelector(".sub-nav");
  var overlayEl = document.querySelector(".menu-overlay");
  closeAllSubNav();
  if (subNavAriaExpanded === "true" || subNavAriaExpanded === true) {
    e.setAttribute("aria-expanded", "false");
    e.classList.remove("is-active");
    removeSubLinksFromTabIndex(subNavLinks);
    subNav.classList.remove("sub-nav--isActive");
    (0, _bodyScrollLock.clearAllBodyScrollLocks)();
  } else {
    window.scrollTo(0, 0);
    e.setAttribute("aria-expanded", "true");
    e.classList.add("is-active");
    body.classList.add("subMenuIsOpen");
    overlayEl.classList.add("is-shown");
    overlayEl.classList.remove("is-hidden");
    addSubLinksFromTabIndex(subNavLinks);
    subNav.classList.add("sub-nav--isActive");
    // showArrowInCorrectSpot(e);
    // disableBodyScroll(subNavParent);
  }
};

var closeSubNav = function closeSubNav(e) {
  var escKey = 27;
  var tabKey = 9;
  var subNavItem = e.target;

  var subNavParent = subNavItem.parentNode.parentNode.parentNode;

  var subNavUl = subNavParent.querySelector(".sub-nav");
  var subNavMenuToggle = subNavParent.querySelector(".nav-item__link");

  console.log(subNavParent);
  console.log(subNavUl);
  console.log(subNavMenuToggle);

  if (e.which === escKey) {
    console.log(subNavParent);
    subNavMenuToggle.setAttribute("aria-expanded", "false");
    subNavUl.classList.remove("sub-nav--isActive");
  }
  if (subNavItem.classList.contains("sub-nav__link--last-item") && e.which === tabKey && e.shiftKey === false) {
    subNavMenuToggle.setAttribute("aria-expanded", "false");
    subNavUl.classList.remove("sub-nav--isActive");
  }
  if (subNavItem.classList.contains("sub-nav__link--first-item") && e.which === tabKey && e.shiftKey === true) {
    subNavMenuToggle.setAttribute("aria-expanded", "false");
    subNavUl.classList.remove("sub-nav--isActive");
  }
};

var addSubNavKeydownListener = function addSubNavKeydownListener(subNavLinks) {
  subNavLinks.forEach(function (link) {
    link.addEventListener("keydown", closeSubNav);
  });
};

var openFirstSubNav = function openFirstSubNav() {
  var menuItemsWithChildren = document.querySelectorAll(".nav-item--has-children");
  if (menuItemsWithChildren.length) {
    var link = menuItemsWithChildren[0].querySelector(".nav-item__link");
    toggleNav(link);
    // showArrowInCorrectSpot(link);
  }
};

var toggleMobileNav = function toggleMobileNav() {
  var mainNavOpenClass = "mainNavIsOpen";
  var body = document.querySelector("body");

  if (body.classList.contains(mainNavOpenClass)) {
    body.classList.remove(mainNavOpenClass);
    closeAllSubNav();
  } else {
    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth"
    });
    body.classList.add(mainNavOpenClass);
    openFirstSubNav();
  }
};

var resetMenu = function resetMenu() {
  var body = document.querySelector("body");
  var overlayEl = document.querySelector(".menu-overlay");
  body.classList.remove("mainNavIsOpen");
  body.classList.remove("subMenuIsOpen");
  overlayEl.classList.remove("is-shown");
  overlayEl.classList.add("is-hidden");
  closeAllSubNav();
  (0, _bodyScrollLock.clearAllBodyScrollLocks)();
};

var setUpMenu = exports.setUpMenu = function setUpMenu() {
  var menuItemsWithChildren = document.querySelectorAll(".nav-item--has-children");
  var mobileMenuToggle = document.getElementById("mobile-nav-toggle");
  var menuOverlay = document.querySelector(".menu-overlay");

  if (menuItemsWithChildren.length) {
    menuItemsWithChildren.forEach(function (menu) {
      menu.addEventListener("click", function (e) {
        if (!e.target.classList.contains("sub-nav__close-button")) {
          toggleNav(e.target);
        } else if (e.target.classList.contains("sub-nav__close-button")) {
          resetMenu();
        }
      });
      var menuLink = menu.querySelector(".nav-item__link");
      menuLink.setAttribute("aria-expanded", "false");
      menuLink.setAttribute("aria-haspopup", "true");

      var subNavLinks = menu.querySelectorAll(".sub-nav__link");

      removeSubLinksFromTabIndex(subNavLinks);
      addSubNavKeydownListener(subNavLinks);
    });
  }
  menuOverlay.addEventListener("click", resetMenu);
  mobileMenuToggle.addEventListener("click", toggleMobileNav);
};